import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ role = null, redirectPath = '/login', children }) {
  const { user, loading } = useAuth();
  console.log(user, "Role is:");

  if (loading || !user) {
  return (
    <div className="min-h-screen flex justify-center items-center">
      <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-pink-500" />
    </div>
  );
}


  if (!user) {
    return <Navigate to={redirectPath} replace />;
  }

  if (role && user.role !== role && user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return children ? children : <Outlet />;
}
